<div class="history-version-container">
  <app-tabs
    [tabs]="tabs"
    [activeTab]="activeTab"
    (tabChanged)="activeTab = $event"
  ></app-tabs>

  <ng-template #generalInfoTemplate>
    <div class="form-content">
      <msf-form-builder
        [fields]="formFields"
        [(model)]="model"
        flexDirection="row"
      ></msf-form-builder>
    </div>
  </ng-template>

  <ng-template #mapTemplate>
    @if (activeTab === 'map' && historyPolygonJson) {
      <div class="map-wrapper">
        <mfs-old-map
          [height]="'100%'"
          [zoom]="13"
          [drawingMode]="false"
          [showControls]="false"
          [isCenterMarker]="false"
          [isCenterControl]="true"
          [isSplitControl]="false"
          [polygonJson]="historyPolygonJson"
        ></mfs-old-map>
      </div>
    } @else if (activeTab === 'map') {
      <div class="map-empty-state">
        {{ 'Field boundaries are missing' | translate }}
      </div>
    }
  </ng-template>
</div>

<div class="actions">
  <p-button
    [severity]="'secondary'"
    label="{{ 'Cancel' | translate }}"
    class="p-button-text button-secondary"
    (click)="cancel()">
  </p-button>

  @if (showRestoreButton) {
    <button
      pButton type="button"
      label="{{ 'Restore this version' | translate }}"
      class="p-button-primary"
      (click)="restore()"
      [loading]="isLoading"
    ></button>
  }
</div>
